import { Injectable } from '@angular/core';
import { Actions} from '@ngrx/effects';
import { ApiService } from '../../services/api.service';


@Injectable()
export class TheoricalLayerEffects {

  constructor(private actions$: Actions, private api: ApiService) {}
}
